import { getAccessToken } from "../lib/auth";
import { parseApiError } from "../lib/api-error";
import type { AppRoleBinding } from "../types/org";

async function fetchAPI<T>(endpoint: string): Promise<T> {
  const token = await getAccessToken();
  const response = await fetch(`/api/app-roles${endpoint}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw await parseApiError(response);
  }

  return response.json();
}

export const appRolesApi = {
  list: () => fetchAPI<{ items: AppRoleBinding[] }>(""),
  get: (name: string) => fetchAPI<AppRoleBinding>(`/${name}`),
};
